export default "__VITE_ASSET__9a4e85ad__"